import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IClearanceApproval, ClearanceApproval } from "@/models/clearance-approval.entity";

export const ClearanceApprovalDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IClearanceApproval> {
  getIdentifier(entity: IClearanceApproval): string {
    return entity.id;
  }

  protected mapEntity(entity: IClearanceApproval): IClearanceApproval {
    return new ClearanceApproval(entity);
  }
})();
